import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  IconButton, // eslint-disable-next-line import/named
  useDisclosure,
} from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import { BurgerIcon, CloseIcon } from '@/shared/ui';

const MobileMenu: FC<{ LinksComponent: FC<{ onClick?: () => void }> }> = ({ LinksComponent }) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <Box display={{ base: 'block', lg: 'none' }}>
      <IconButton
        aria-label={t('common.header.menu.open')}
        aria-labelledby={t('common.header.menu.open')}
        gridArea='menu'
        icon={<BurgerIcon boxSize={6} />}
        variant='iconButton'
        onClick={onOpen}
      />
      <Drawer
        isOpen={isOpen}
        placement='right'
        size='xs'
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent overflowY='auto'>
          <DrawerHeader
            as='div'
            display='flex'
            justifyContent='end'
            px='md'
          >
            <IconButton
              aria-label={t('common.header.menu.close')}
              aria-labelledby={t('common.header.menu.close')}
              icon={<CloseIcon boxSize={6} />}
              variant='iconButton'
              onClick={onClose}
            />
          </DrawerHeader>
          <DrawerBody
            as='nav'
            display='flex'
            flexDirection='column'
            gap='4'
            pt='lg'
          >
            <LinksComponent onClick={onClose} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default MobileMenu;
